<template>
    <div class="DoctorScheduling">
        <Row class="topheadmod">
            <Col span="24" style="text-align: right;" >
                <span style="margin-right: 15px;">
                    <Select v-model="dateValue" style="width: 100px; text-align: center;" @on-change="handleWeek(dateValue)">
                        <Option v-for="(item , index) in selectList" :value="item" :key="index">第{{ item }}周</Option>
                    </Select>
                </span>
                <span >
                    <Input v-model="selectdate" disabled class="selectdate" />
                </span>
            </Col>
        </Row>  
        <div class="schedulmod">
            <div class="headrow">
                <div class="title">时间段</div>    
                <div v-for="(item , index) in tablethList" :value="item" :key="index">
                    {{item.week}} {{item.date}}
                </div>
            </div> 
            <div class="bodyrow">
                <div class="title">
                    <div class="colmomd">
                        <span style="background:#2d8cf0;">上午</span>
                    </div>
                    <div class="colmomd">
                        <span style="background:#19be6b;">下午</span>
                    </div>
                </div>
                <div class="cont" v-for="(item , index) in tableData" :key="index">
                    <div class="continfo" >
                        <div class="taginput" @click="handleAdd(index,'am')">
                            <div v-if="item.AM.length==0" class="taginputfont">请添加值班医生</div>
                            <div v-else class="">
                                <Tag v-for="(items,num) in item.AM" :key="items.ID" :name="items.DocName" closable @on-close="handleClose(index,num,'am')">{{ items.DocName }}</Tag>
                            </div>
                            
                        </div>
                    </div>
                    <div class="continfo" >
                        <div class="taginput" @click="handleAdd(index,'pm')">
                            <div v-if="item.PM.length==0" class="taginputfont">请添加值班医生</div>
                            <div v-else >
                                <Tag v-for="(items,num) in item.PM" :key="items.ID" :name="items.DocName" closable @on-close="handleClose(index,num,'pm')">{{ items.DocName }}</Tag>
                            </div>
                            
                        </div>
                    </div>
                </div>  
            </div>
        </div>
        <div class="btncont">
            <Button type="primary" size="large" ghost @click="copyLastWeek()">复制上周</Button>
            <Button type="primary" size="large" @click="saveDrTask()">保存本周</Button>
        </div>
        <Modal
            class="modalmod"
            v-model="tagmodal"
            title="选择医生"
            @on-ok="ok"
            @on-cancel="cancel">
            <Row class="modalmain">
                <Col span="12">
                    <Input search enter-button="检索" v-model="searchvalue" placeholder="请输入医生姓名检索" @on-search="searchDoctor" />
                    <div class="doctorlist">
                        <div style="border-bottom: 1px solid #e9e9e9;margin-bottom:6px;">
                            <Checkbox
                                :indeterminate="indeterminate"
                                :value="checkAll"
                                @click.prevent.native="handleCheckAll">全选</Checkbox>
                        </div>
                        <CheckboxGroup v-model="checkdoctor"  @on-change="checkdoctorChange">
                            <Checkbox  v-for="(item , index) in doctorList" :key="item.ID" :label="item.ID" >
                                <img :src="item.Img ? item.Img : require('../assets/baseImg.jpg')" style="margin-right:5px;">
                                <span>{{item.DocName}}</span>
                            </Checkbox>
                            
                        </CheckboxGroup>
                    </div>
                </Col>
                <Col span="12">
                    <div class="">
                        <Tag v-for="(item,index) in doctorShow" :key="index" :name="item.DocName" closable @on-close="handlemodalClose(index)">{{ item.DocName }}</Tag>
                    </div>
                </Col>
            </Row>
        </Modal>
    </div>
</template>

<script>
    import { Row, Col, Select,Option, Button ,Modal ,Tag ,Input ,Checkbox ,CheckboxGroup} from "view-design";
    import Request from "../utils/request";
    import config  from '../config/index';
    import dayjs from 'dayjs';
    import _ from 'lodash'
    import weekOfYear from 'dayjs/plugin/weekOfYear';
    import weekYear from 'dayjs/plugin/weekYear';
    import isoWeek from 'dayjs/plugin/isoWeek';
    import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
    import isLeapYear from 'dayjs/plugin/isLeapYear';
    dayjs.extend(weekOfYear);
    dayjs.extend(weekYear)
    dayjs.extend(isoWeek)
    dayjs.extend(isoWeeksInYear)
    dayjs.extend(isLeapYear)
    export default {
        components: {
            Row, Col, Select,Option,Button,Modal,Tag ,Input,Checkbox ,CheckboxGroup
        },
        data() {
            return {
                CenterID:JSON.parse(localStorage.getItem("Role")).CenterID,
                tagmodal: false,
                searchvalue:'',
                indeterminate: true,
                checkAll: false,
                checkdoctor:[],
                checkdoctorList:[],
                doctorList:[],

                
                // 选择周和日期
                dateValue:'1',
                selectList: [],
                selectdate: '',

                // 表格标题
                tablethList:[
                    {week:'星期一',date:''},
                    {week:'星期二',date:''},
                    {week:'星期三',date:''},
                    {week:'星期四',date:''},
                    {week:'星期五',date:''},
                    {week:'星期六',date:''},
                    {week:'星期日',date:''},
                ],
                onindex:'',
                ontitle:'',
                tableData:[
                    {
                        WorkDate:'',
                        AM:[],
                        PM:[],
                        AMID:'',
                        PMID:''
                    },
                    {
                        WorkDate:'',
                        AM:[],
                        PM:[],
                        AMID:'',
                        PMID:''
                    },
                    {
                        WorkDate:'',
                        AM:[],
                        PM:[],
                        AMID:'',
                        PMID:''
                    },
                    {
                        WorkDate:'',
                        AM:[],
                        PM:[],
                        AMID:'',
                        PMID:''
                    },
                    {
                        WorkDate:'',
                        AM:[],
                        PM:[],
                        AMID:'',
                        PMID:''
                    },
                    {
                        WorkDate:'',
                        AM:[],
                        PM:[],
                        AMID:'',
                        PMID:''
                    },
                    {
                        WorkDate:'',
                        AM:[],
                        PM:[],
                        AMID:'',
                        PMID:''
                    },
                ],
            }
        },
        computed:{
            doctorShow(){
                var newarr = []
                newarr = _.intersectionWith(this.doctorList, this.checkdoctor, function(key,val){
                    return key.ID == val
                });
                return newarr
            }
        },
        methods: {
            // 添加
            handleAdd (index,title) {
                this.tagmodal = true;
                this.onindex = index
                this.ontitle = title;
                let checkdoctor = []
                if(title == 'am'){
                    this.tableData[index].AM.map(item=>{
                        checkdoctor.push(item.ID)
                    })
                }else{
                    this.tableData[index].PM.map(item=>{
                        checkdoctor.push(item.ID)
                    })
                }
                this.checkdoctor = checkdoctor
                if(checkdoctor.length){
                    if(this.checkdoctorList.length == checkdoctor.length){
                        this.indeterminate = false;
                        this.checkAll = true;
                    }else{
                        this.indeterminate = true;
                        this.checkAll = false;
                    }
                }else{
                    this.checkAll = false;
                    this.indeterminate = false;
                }
            },
            // 全选
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;

                if (this.checkAll) {
                    this.checkdoctor = this.checkdoctorList;
                    // console.log(this.checkdoctor,this.checkdoctorList,this.doctorShow,1)
                } else {
                    this.checkdoctor = [];
                    // console.log(this.checkdoctor,this.checkdoctorList,2)
                }
            },
            checkdoctorChange (data) {
                if (data.length === this.checkdoctorList.length) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
            handlemodalClose(index){
                this.checkdoctor.splice(index, 1);
                this.checkAll = false
                if(this.checkdoctor.length){
                    this.indeterminate = true
                }else{
                    this.indeterminate = false
                }
            },
            ok () {
                var num = this.onindex
                if(this.ontitle == 'am'){
                    let doctorShow = []
                    this.doctorShow.map(item=>{
                        let obj = {
                            ID:item.ID,
                            DocName:item.DocName,
                            UserJid:item.UserJid
                        }
                        doctorShow.push(obj)
                    })
                    this.tableData[num].AM = doctorShow
                }else{
                    let doctorShow = []
                    this.doctorShow.map(item=>{
                        let obj = {
                            ID:item.ID,
                            DocName:item.DocName,
                            UserJid:item.UserJid
                        }
                        doctorShow.push(obj)
                    })
                    this.tableData[num].PM = doctorShow
                }
            },
            cancel () {
                //this.$Message.info('Clicked cancel');
            },
            // 删除
            handleClose (index,num,title) {
                if(title == 'am'){
                    this.tableData[index].AM.splice(num, 1);
                }else{
                    this.tableData[index].PM.splice(num, 1);
                }
            },
            // 计算时间
            gettimehandle(){
                // 获取当前是第几周
                this.dateValue = dayjs().week()
                // 当年有多少周
                var yearlast = dayjs().isoWeeksInYear();
                var selectarr = new Array(parseInt(yearlast));
                for(var i=0;i<selectarr.length;i++){
                    selectarr[i] = i + 1;
                }
                // 当前周具体时间
                this.selectList = selectarr;
                this.selectdate = dayjs().isoWeekday(1).format('YYYY-MM-DD') +' 至 '+ dayjs().isoWeekday(7).format('YYYY-MM-DD')
                //表格标题  
                this.tablethList.map((item,index)=>{     
                    item.date =  dayjs().isoWeekday(index+1).format('MM-DD')
                })
                this.tableData.map((item,index)=>{     
                    item.WorkDate =  dayjs().isoWeekday(index+1).format('YYYY-MM-DD')
                    item.AM = []
                    item.PM = []
                    item.AMID = ''
                    item.PMID = ''
                })
                this.GetScheduling(this.selectdate.split(" 至 ")[0],this.selectdate.split(" 至 ")[1])
            },
            // 切换时间
            handleWeek(value){
                this.dateValue = value;
                
                this.selectdate = dayjs().week(value).isoWeekday(1).format('YYYY-MM-DD') +' 至 '+ dayjs().week(value).isoWeekday(7).format('YYYY-MM-DD')
                
                //表格标题
                this.tablethList.map((item,index)=>{     
                    item.date = dayjs().week(value).isoWeekday(index+1).format('MM-DD')
                })
                this.tableData.map((item,index)=>{     
                    item.WorkDate = dayjs().week(value).isoWeekday(index+1).format('YYYY-MM-DD')
                    item.AM = []
                    item.PM = []
                    item.AMID = ''
                    item.PMID = ''
                })
                this.GetScheduling(this.selectdate.split(" 至 ")[0],this.selectdate.split(" 至 ")[1])
            },
            // 检索医生
            searchDoctor(){
                let newarr = _.sortBy(this.doctorList, (item)=> {
                    if(item.DocName.match(this.searchvalue)){
                        return item.DocName;
                    }
                });
                this.doctorList=newarr
            },
            // 获取医生列表
            DoctorList(){
                Request.getRequest(config.SXG_baseUrl + '/api/currency/GetRecordDetail',{
                    tablename:'DocList',
                    fields:'ID,DocName,UserJid,ImgUrl',
                    searchkey2:'DocType',
                    searchvalue2:'中心',
                    searchkey3:'CenterID',
                    searchvalue3:this.CenterID,
                    searchkey:'Level',
                    searchvalue:'A'
                }).then(res=>{
                    // console.log(res)
                    if(res.code == 200){
                        let newarr = []
                        for (var i = 0; i <res.data.length; i++) {
                            var vote = {
                                ID:res.data[i].ID,
                                DocName:res.data[i].DocName,
                                Img:res.data[i].ImgUrl,
                                UserJid:res.data[i].UserJid
                            };
                            newarr.push(vote);
                        }
                        this.checkdoctorList= res.data.map(item => {return item.ID});
                        this.doctorList = newarr
                    }else{
                        this.$Message.info(res.message)
                    }
                })
            },
            // 获取排班数据
            GetScheduling(startDate,endData,copyFlag=false){
                Request.postRequest(config.WJ_baseUrl + '/api/schedule/PostGetScheduleList',{
                    StartDate:startDate,
                    EndDate:endData,
                    CenterID:this.CenterID,
                }).then(res=>{
                    // console.log(res,'获取排班数据')
                    if(res.code == 200){
                        res.data.map(item=>{
                            if(item.WorkDate.split('T')[0] == startDate){
                                if(item.AMOrPM == "AM"){
                                    if(!copyFlag){
                                        this.tableData[0].AMID = item.ID
                                    }
                                    this.tableData[0].AM = (JSON.parse(item.CDID))
                                }else{
                                    if(!copyFlag){
                                        this.tableData[0].PMID = item.ID
                                    }
                                    this.tableData[0].PM = (JSON.parse(item.CDID))
                                }
                            }else if(item.WorkDate.split('T')[0] == dayjs(startDate).add(1,'day').format('YYYY-MM-DD')){
                                if(item.AMOrPM == "AM"){
                                    if(!copyFlag){
                                        this.tableData[1].AMID = item.ID
                                    }
                                    this.tableData[1].AM = (JSON.parse(item.CDID))
                                }else{
                                    if(!copyFlag){
                                        this.tableData[1].PMID = item.ID
                                    }
                                    this.tableData[1].PM = (JSON.parse(item.CDID))
                                }
                            }else if(item.WorkDate.split('T')[0] == dayjs(startDate).add(2,'day').format('YYYY-MM-DD')){
                                if(item.AMOrPM == "AM"){
                                    if(!copyFlag){
                                        this.tableData[2].AMID = item.ID
                                    }
                                    this.tableData[2].AM = (JSON.parse(item.CDID))
                                }else{
                                    if(!copyFlag){
                                        this.tableData[2].PMID = item.ID
                                    }
                                    this.tableData[2].PM = (JSON.parse(item.CDID))
                                }
                            }else if(item.WorkDate.split('T')[0] == dayjs(startDate).add(3,'day').format('YYYY-MM-DD')){
                                if(item.AMOrPM == "AM"){
                                    if(!copyFlag){
                                        this.tableData[3].AMID = item.ID
                                    }
                                    this.tableData[3].AM = (JSON.parse(item.CDID))
                                }else{
                                    if(!copyFlag){
                                        this.tableData[3].PMID = item.ID
                                    }
                                    this.tableData[3].PM = (JSON.parse(item.CDID))
                                }
                            }else if(item.WorkDate.split('T')[0] == dayjs(startDate).add(4,'day').format('YYYY-MM-DD')){
                                if(item.AMOrPM == "AM"){
                                    if(!copyFlag){
                                        this.tableData[4].AMID = item.ID
                                    }
                                    this.tableData[4].AM = (JSON.parse(item.CDID))
                                }else{
                                    if(!copyFlag){
                                        this.tableData[4].PMID = item.ID
                                    }
                                    this.tableData[4].PM = (JSON.parse(item.CDID))
                                }
                            }else if(item.WorkDate.split('T')[0] == dayjs(startDate).add(5,'day').format('YYYY-MM-DD')){
                                if(item.AMOrPM == "AM"){
                                    if(!copyFlag){
                                        this.tableData[5].AMID = item.ID
                                    }
                                    this.tableData[5].AM = (JSON.parse(item.CDID))
                                }else{
                                    if(!copyFlag){
                                        this.tableData[5].PMID = item.ID
                                    }
                                    this.tableData[5].PM = (JSON.parse(item.CDID))
                                }
                            }else if(item.WorkDate.split('T')[0] == dayjs(startDate).add(6,'day').format('YYYY-MM-DD')){
                                if(item.AMOrPM == "AM"){
                                    if(!copyFlag){
                                        this.tableData[6].AMID = item.ID
                                    }
                                    this.tableData[6].AM = (JSON.parse(item.CDID))
                                }else{
                                    if(!copyFlag){
                                        this.tableData[6].PMID = item.ID
                                    }
                                    this.tableData[6].PM = (JSON.parse(item.CDID))
                                }
                            }
                        })
                        // console.log(this.tableData)
                    }else{
                        this.$Message.info(res.message)
                    }
                })
            },
            //复制上周
            copyLastWeek(){
                let startDate = dayjs(this.selectdate.split(" 至 ")[0]).subtract(7,'day').format('YYYY-MM-DD')
                let endDate = dayjs(this.selectdate.split(" 至 ")[0]).subtract(1,'day').format('YYYY-MM-DD')
                // console.log(startDate,endDate)
                this.tableData.map(item=>{     
                    item.AM = []
                    item.PM = []
                })
                this.GetScheduling(startDate,endDate,true)
            },
            // 保存排班数据
            saveDrTask(){
                let sendData = {
                    ScheduleList:[]
                }
                this.tableData.map(item=>{
                    if(item.AM.length || item.AMID){
                        let obj = {
                            ID:item.AMID,
                            WorkDate:item.WorkDate,
                            AMOrPM:'AM',
                            CenterID:this.CenterID,
                            CDID:item.AM
                        }
                        sendData.ScheduleList.push(obj)
                    }
                    if(item.PM.length || item.PMID){
                        let obj = {
                            ID:item.PMID,
                            WorkDate:item.WorkDate,
                            AMOrPM:'PM',
                            CenterID:this.CenterID,
                            CDID:item.PM
                        }
                        sendData.ScheduleList.push(obj)
                    }
                })
                // console.log(sendData)
                Request.postRequest(config.WJ_baseUrl + '/api/schedule/PostSaveSchedule',sendData).then(res=>{
                    console.log(res)
                    if(res.code == 200){
                        this.$Message.success('保存成功')
                    }else{
                        this.$Message.error(res.message)
                    }
                })
            }
        },
        created(){
            this.$emit('funChangeTitle','医生排班','3-2')  ;
            this.gettimehandle();
            this.DoctorList()
        }
    }
</script>

<style lang="less">
.DoctorScheduling{
    padding: 10px 30px;
    .topheadmod{
        padding: 30px 0;
        border-bottom: 1px solid #ddd;
        .ivu-col-span-24>span{
            display: inline-block;
        }
        .selectdate .ivu-input[disabled]{
            background: #f1f1f1;
            color: #444;
            width: 200px;
            text-align: center;
        }
    }
    .tabbtnstyle{
        display: inline-block;
        margin-right: 10px;
        p{
            .ivu-btn-primary{
                background: rgba(1, 101, 184, 0.3);
                color: #333333;
                border: none;
            }
        }
        p.active{
            .ivu-btn-primary{
                background: #1890ff;
                color: #fff;
            }
        }
    }
    .schedulmod{
        margin: 20px 0;
        border: 1px solid #ddd;
        border-radius: 4px;
        >div{
            display: flex;
            border-top: 1px solid #ddd;
            >div{
                width: 13%;
                text-align: center;
                position: relative;
            }
            >div::after{
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                left: 0; 
                top: 0;
                width: 1px;
                border-left: 1px dashed #ddd;
            }
            div.title::after{
                display: none;
            }
            div.title{
                width: 9%;
                .colmomd{
                    height: 225px;
                    display: flex;
                    align-items:center;
                    span{
                        display: block;
                        width: 50px;
                        border-radius: 50%;
                        line-height: 50px;
                        color: #fff;
                        font-size: 16px;
                        margin: 0 auto;
                    }
                }
                .colmomd:first-child{
                    border-bottom: 1px solid #ddd;
                }
            }
        }
        div.headrow{
            border: none;
            font-weight: bold;
            line-height: 30px;
            div{
                padding: 7px 0;
            }
            div::after{
                display: none;
            }
        }
        div.bodyrow{
            .continfo{
                height: 225px;
                padding: 10px;
            }
            .continfo:first-child{
                border-bottom: 1px solid #ddd;
            }
            .taginput{
                padding: 5px;
                text-align: left;
                height: 200px;
                border: 1px solid #ddd;
                overflow-y: auto;
                cursor: pointer;
                .ivu-tag{
                    margin: 0px 5px 5px 0;
                    height: auto;
                }
                .taginputfont{
                    font-size: 13px;
                    color: #999;
                }
            }
        }
    }
    .btncont{
        text-align: center;
        padding: 25px;
        .ivu-btn{
            margin: 0 10px;
        }
        
    }
    
}
.modalmod{
    .ivu-modal{
        width: 700px !important;
    }
}
.modalmain{
    height: 480px;
    .ivu-col{
        padding: 0 15px;
        height: 100%;
        overflow: auto;
        .doctorlist{
            margin: 10px 0;
            .ivu-checkbox-wrapper{
                display: block;
                line-height: 30px;
                margin: 10px 0;
                .ivu-checkbox{
                    margin-right: 7px;
                }
                img{
                    width: 30px;
                    height: 30px;
                    vertical-align: middle;
                    border-radius: 50%;
                }
            }
        }
        .ivu-tag{
            height: auto;
        }
        
    }
} 
.modalmain::before{
    content: '';
    position: absolute;
    left: 50%;
    width: 1px;
    top: 0;
    height: 100%;
    bottom: 0;
    background: #e4e4e4;
}
</style>
